import { EmptyContent } from './styles'
import EmptyImageSrc from '../../../../assets/dashboard/empty-image.png'

const Empty = () => {
  return (
    <EmptyContent>
      <img
        src={EmptyImageSrc}
        alt="Ilustração de uma pessoa interagindo com um painel de informações"
        className="image-svg"
      />
      <div className="text">
        <h2 className="title">Você ainda não selecionou nenhum curso.</h2>
        <p className="description">
          Vá ao canto superior direito e selecione o curso que deseja visualizar sua evolução.
        </p>
      </div>
    </EmptyContent>
  )
}

export default Empty
